var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationcross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/locationcross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4641 6.525C14.6841 3.0525 11.6541 1.5 8.99908 1.5H8.99158C6.34408 1.5 3.32158 3.0525 2.53408 6.5175C1.64908 10.3875 4.01908 13.665 6.16408 15.735C6.92437 16.4709 7.94098 16.8824 8.99908 16.8825C10.0191 16.8825 11.0391 16.5 11.8266 15.735C13.9716 13.665 16.3416 10.395 15.4641 6.525ZM10.8966 10.1175C10.7841 10.23 10.6416 10.2825 10.4991 10.2825C10.3566 10.2825 10.2141 10.23 10.1016 10.1175L9.01408 9.03L7.89658 10.1475C7.78408 10.26 7.64158 10.3125 7.49908 10.3125C7.35658 10.3125 7.21408 10.26 7.10158 10.1475C6.99697 10.0416 6.9383 9.89882 6.9383 9.75C6.9383 9.60118 6.99697 9.45835 7.10158 9.3525L8.21908 8.235L7.13158 7.1475C7.02697 7.04165 6.9683 6.89882 6.9683 6.75C6.9683 6.60118 7.02697 6.45835 7.13158 6.3525C7.34908 6.135 7.70908 6.135 7.92658 6.3525L9.01408 7.44L10.0641 6.39C10.2816 6.1725 10.6416 6.1725 10.8591 6.39C11.0766 6.6075 11.0766 6.9675 10.8591 7.185L9.80908 8.235L10.8966 9.3225C11.1141 9.54 11.1141 9.8925 10.8966 10.1175Z",
    fill: "#2E4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationcross);
export default __webpack_public_path__ + "static/media/locationcross.05afbc238541fb22e1af3da966ff50dd.svg";
export { ForwardRef as ReactComponent };